import { TypographyVariantsOptions } from '@mui/material/styles';

export const typography: TypographyVariantsOptions = {
    button: {
        textTransform: 'none',
    },
    fontFamily: 'Merriweather Sans, sans-serif', // Google Font
};
